var UserGender = {
  MISTER: 0, // Monsieur
  MRS: 1, // Madame
};

module.exports = UserGender;
